import axios from "../utils/axios";

// 🏢 Get address
export const getAddressByUser = async (userId) => {
  const response = await axios.get("/api/Address/GetListByUser", {
    params: { userId },
  });
  //console.log(response);
  return response.data;
};

// 🏢 Get single address
export const getSingleAddress = async (addressId) => {
  const response = await axios.get("/api/Address/GetSingleItem", {
    params: { Id: addressId },
  });
  //console.log(response);
  return response.data;
};

// 🏢 Add address
export const createAddress = async (address) => {
  const response = await axios.post("/api/Address/Create", address);
  //console.log(response);
  return response.data;
};

// 🏢 Update address
export const editAddress = async (address) => {
  const response = await axios.post("/api/Address/Update", address);
  //console.log(response);
  return response.data;
};

// remove address
export const deleteAddress = async (addressId) => {
  const response = await axios.post(
    "/api/Address/Delete",
    {
      id: addressId,
      name: "string",
      phoneNumber: "string",
      mobilePhoneNumber: "string",
      province: "string",
      streetName: "string",
      otherDetail: "string",
      isPrimary: true,
      isReturnAddress: true,
    },
  );
  //console.log(response);
  return response.data;
};

export const setPrimaryAddress = async (addressId) => {
  const response = await axios.post("/api/Address/SetPrimaryAddress", null, {
    params: { addressId },
  });
  //console.log(response);
  return response.data;
};
